import { render, staticRenderFns } from "./xxzpSave.vue?vue&type=template&id=12357288&scoped=true&"
import script from "./xxzpSave.vue?vue&type=script&lang=js&"
export * from "./xxzpSave.vue?vue&type=script&lang=js&"
import style0 from "./xxzpSave.vue?vue&type=style&index=0&id=12357288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12357288",
  null
  
)

export default component.exports